import { V2 } from 'types/swagger/clarifai-api';
import { fetch } from 'utils/request';

export const getFeaturedModels = (args: { sessionToken?: string } = {}) => {
  const featuredModelsQuery = `?featured_only=true&additional_fields=stars&additional_fields=presets`;
  return fetch<V2.V2ListModels3.ResponseBody>({
    path: `/api/_api/v2/models${featuredModelsQuery}`,
    sessionToken: args.sessionToken,
  });
};
